// movieService.js
import axios from "axios"
import { API_BASE_URL } from "../config/api"

// export const fetchMoviesByEmotion = async (
//   emotion,
//   intensity,
//   page = 1,
//   limit = 10
// ) => {
//   try {
//     const response = await axios.post(`${API_BASE_URL}/movies/emotions`, {
//       emotion,
//       intensity,
//       page,
//       limit,
//     })
//     return response.data.movies
//   } catch (error) {
//     console.error("Error fetching movies by emotion:", error)
//     throw error
//   }
// }



export const fetchMoviesByEmotion = async (emotion, intensity, page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/movies/emotions`, {
      params: { emotion, intensity, page, limit },
    })
    return response.data.movies
  } catch (error) {
    console.error("Error fetching movies by emotion:", error)
    throw error
  }
}

export const fetchMoviesByName = async (query, page = 1, limit = 20) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/movies/search`, {
      params: { query, page, limit },
    })
    return {
      movies: response.data.movies,
      totalResults: response.data.totalResults,
    }
  } catch (error) {
    console.error("Error fetching movies by name:", error)
    throw error
  }
}

export const findMovieById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/movies/${id}`)
    return response.data
  } catch (error) {
    console.error("Error fetching movies by name:", error)
    throw error
  }
}

export const fetchTimeline = async (movieId, buckets = 100) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/movies/${movieId}/timeline`, {
      params: { buckets },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching timeline:", error)
    throw error
  }
}

// Paginated movie feed for the Movie Space Wheel
export const fetchWheelMovies = async (page = 1, limit = 30, emotion = null, period = null) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/movies/wheel/feed`, {
      params: {
        page,
        limit,
        ...(emotion ? { emotion } : {}),
        ...(period?.year ? { year: period.year } : {}),
        ...(period?.month ? { month: period.month } : {}),
      },
    })
    return response.data // { movies, page, emotion, year, month, hasMore }
  } catch (error) {
    console.error("Error fetching wheel movies:", error)
    throw error
  }
}

export const castVote = async (movieId, position, emotion, sessionId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/movies/${movieId}/votes`, {
      position,
      emotion,
      sessionId,
    })
    return response.data
  } catch (error) {
    console.error("Error casting vote:", error)
    throw error
  }
}
